const defaultTooltipOptions = {
    hideWhileSpinning: true,
    changeVisibilityNearExtremeFrames: false,
};

export { defaultTooltipOptions };
